import React, { useContext } from "react"
import { Menu, Popover } from "antd"
import { ThemeContext } from "@/contexts/ThemeContext"
import { MenuItemType } from "@/components/PHMenu/MenuType"
import "./PHMenu.less"
import { UserContext } from "@/contexts/SessionContext"
import { useHistory } from "react-router-dom"
import { discoverInsightsLink } from "@/utils/constants"
import { LineChartOutlined } from "@ant-design/icons"
import PHLogoBlue from "../PHLogo-blue.png"
import PHIntercomIcon from "../../assets/intercom.png"

export const PHMenu = ({
  list,
  selectedKeys
}: {
  list: Array<MenuItemType>
  selectedKeys: Array<string>
}): JSX.Element => {
  const { theme } = useContext(ThemeContext)
  const { session } = useContext(UserContext)
  const history = useHistory()
  function handleSelect({ key }: { key: number | string }): void {
    const item = list.find((item: MenuItemType) => item.key === key) || list[0]
    if (typeof item.outerJump === "function") {
      item.outerJump(session.currentCustomer.id)
    } else {
      const routerFnOrPath = item.router
      history.push(routerFnOrPath(session.currentCustomer.id))
    }
  }
  const content = (
    <div>
      <p>
        If you don’t have access to DiscoverInsights,
        <br />
        reach out to us via the chat below.
      </p>
      <div className="intercom">
        <img className="intercom-icon" src={PHIntercomIcon} alt="PredictiveHire Intercom Logo" />
      </div>
    </div>
  )

  const alignConfig = {
    offset: [70, 0] // the offset sourceNode by 70px in x and 0px in y
  }

  return (
    <div>
      <img className="phc-logo" alt="Predictive Hire Logo" src={PHLogoBlue} />
      <Menu
        defaultSelectedKeys={selectedKeys}
        mode="inline"
        theme={theme}
        onClick={handleSelect}
        selectedKeys={selectedKeys}
      >
        {list.map(
          (item: MenuItemType): JSX.Element => {
            return (
              <Menu.Item key={item.key}>
                {item.icon}
                {<span>{item.title}</span>}
              </Menu.Item>
            )
          }
        )}
        <Menu.Item>
          <Popover content={content} trigger="hover" placement="bottomLeft" align={alignConfig}>
            <LineChartOutlined />
            <a href={discoverInsightsLink} target="_blank" rel="noopener noreferrer">
              DISCOVER INSIGHTS
            </a>
          </Popover>
        </Menu.Item>
      </Menu>
    </div>
  )
}

export default PHMenu
